export enum TipoCanalComunicacao {
    TELEFONE = "TELEFONE",
    EMAIL  = "EMAIL",
    SMS = "SMS",
    CARTA = "CARTA",
    OUTROS = "OUTROS",
}

export const getCanalComunicacaoFormatado = (situacaoAcordo : TipoCanalComunicacao) => {
    switch(situacaoAcordo){
        case TipoCanalComunicacao.TELEFONE:
            return 'Telefone'
        case TipoCanalComunicacao.EMAIL:
            return 'Email'
        case TipoCanalComunicacao.SMS:
            return 'SMS'
        case TipoCanalComunicacao.CARTA:
            return 'Carta'
        case TipoCanalComunicacao.OUTROS:
            return 'Outros'
    }

}
